import * as React from "react"

import { ShellContext, type ShellContextValue } from "@/providers/shell-context"

export function ShellProvider({ children }: { children: React.ReactNode }) {
  const [currentWorkspaceId, setCurrentWorkspaceId] = React.useState<string | null>(null)
  const [commandPaletteOpen, setCommandPaletteOpen] = React.useState(false)

  const value = React.useMemo<ShellContextValue>(
    () => ({
      currentWorkspaceId,
      setCurrentWorkspaceId,
      commandPaletteOpen,
      setCommandPaletteOpen,
    }),
    [currentWorkspaceId, commandPaletteOpen]
  )

  return <ShellContext.Provider value={value}>{children}</ShellContext.Provider>
}
